import { Translate } from "components/common/Translate/Translate";
import { useAppSelector } from "store/store";
import tinycolor from "tinycolor2";
import { Chip, rgbShade, rgbTint } from "./Chip/Chip";

export const ColorVariants = ({ useHeadingTag = true }) => {
    const selectedColor = useAppSelector((store) => store.colorPicker.selectedColor);
    if (!selectedColor) return null;
    const tiny = tinycolor(selectedColor.hex);
    const rgb = tiny.toRgb();
    return (
        <div className="flex flex-col gap-6 text-black dark:text-white px-4 lg:px-0 py-16">
            {useHeadingTag ? (
                <h2 className="text-xl font-semibold">
                    <Translate keyName="color-variations-title" />
                </h2>
            ) : (
                <span className="text-xl font-semibold">
                    <Translate keyName="color-variations-title" />
                </span>
            )}

            <span>
                <Translate keyName="color-variations-sub-title" />
            </span>
            <div className="font-semibold capitalize">
                <Translate keyName="shades" />
            </div>
            <div className="grid lg:grid-cols-11 mt-6">
                {Array.from(Array(10).keys()).map((i) => (
                    <Chip key={i} {...rgbShade(rgb, i)} i={i} />
                ))}
                <Chip r={0} g={0} b={0} i={10} />
            </div>
            <div className="font-semibold mt-4 capitalize">
                <Translate keyName="tints" />
            </div>
            <div className="grid lg:grid-cols-11 mt-6">
                {Array.from(Array(10).keys()).map((i) => (
                    <Chip key={i} {...rgbTint(rgb, i)} i={i} />
                ))}
                <Chip r={255} g={255} b={255} i={10} />
            </div>
        </div>
    );
};
